import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthComponent } from './auth/auth.component';
import { AuthGuard } from './auth/auth.guard';
import { Navigations } from './shared/models/navigation.interface';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
    },
    {
        path: 'auth',
        component: AuthComponent,
    },
    {
        path: Navigations.TIME_TRIVIA.path,
        canActivate: [AuthGuard],
        loadChildren: () => import('./trivia-game/trivia-game.module').then(m => m.TriviaGameModule)
    },
    {
        path: Navigations.PREDICT_WIN.path,
        canActivate: [AuthGuard],
        loadChildren: () => import('./predict-win/predict-win.module').then(m => m.PredictWinModule)
    },
    { path: '**', redirectTo: ''}
];
